import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import './SubmitModal.scss';
import { IsOnlyNumbers } from '../../utils/helpers';
import FormField from '../FormField';
import Button from '../Button';
import SubmitModalWrapper from './SubmitModalWrapper';

const SubmitModal = ({ showModal, sendInfo, onClose, colorCode }) => {
  if (!showModal) return null;

  return (
      <SubmitModalWrapper
        showModal={showModal} 
        sendInfo={sendInfo}
        onClose={onClose}
        colorCode={colorCode}
      >
        <Formik
          initialValues={{
            nombre: '',
            email: '',
            telefono: '',
            politica: 'politica',
          }}
          validationSchema={Yup.object().shape({
            // cedula: Yup.string().required('Requerido'),
            nombre: Yup.string().required('Requerido'),
            email: Yup.string()
              .email('Ingrese un email válido')
              .required('Requerido'),
            telefono: Yup.number().integer().test('len', 'El télefono debe contener 8 digitos y solo números', val => {
              const hasOnlyNumbers = IsOnlyNumbers(val);
              if (!hasOnlyNumbers) {
                return false;
              }
              return !!val && (val).toString().length === 8;
            }),
            politica: Yup.string().required('Requerido'),
          })}
          onSubmit={values => {
            sendInfo(values);
            /*sendAvaluo(toProperties(formik.values), values);
            history.push('/avaluo/gracias');*/
          }}
          validateOnMount={true}
        >
          {formik2 => (
            <form className="cotizacion-rapida__form" onSubmit={formik2.handleSubmit}>
              <div
                //className="cotizacion-rapida__form"
                style={{ justifyContent: 'center' }}
              >
                <p className="cotizacion-rapida__header-text">Llená tus datos</p>
                <p className="cotizacion-rapida__header-textfield">¡Ingresá tus datos ya y aplicá el descuento en tu próximo chuzo!</p>
                <br></br>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    id="nombre"
                    name="nombre"
                    placeholder="Eje: Ana Solano Rojas"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.nombre}
                    touched={formik2.touched.nombre}
                    error={formik2.errors.nombre}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Nombre completo</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    label="Escribe tu email"
                    id="email"
                    name="email"
                    placeholder="Eje: anasol_ro@gmail.com"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.email}
                    touched={formik2.touched.email}
                    error={formik2.errors.email}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Correo electrónico</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    label="Escribe tu telefono"
                    id="telefono"
                    name="telefono"
                    placeholder="Eje: 8888-8888"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.telefono}
                    touched={formik2.touched.telefono}
                    error={formik2.errors.telefono}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Número de teléfono</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    url="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf"
                    label=""
                    id="politica"
                    name="politica"
                    type="radio"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.politica}
                    touched={formik2.touched.politica}
                    error={formik2.errors.politica}
                    options={[
                      {
                        component: (
                          <>
                            <div className="classic-form__field--anchor">
                            *<a target="_blank" href="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf">ACEPTO POLÍTICAS DE PRIVACIDAD</a> Y <a target="_blank" href="/wp-content/themes/veinsa/files/terminos_condiciones_veinsamotors.pdf">TÉRMINOS Y CONDICIONES</a>
                            </div>
                          </>
                        ),
                        value: 'politica',
                        label: 'Acepto Política de privacidad',
                      },
                    ]}
                  />
                </div>
                <br></br>
                <Button 
                  submit
                  ui="circular"
                  disabled={!formik2.isValid} type="red">
                  Aplicar cupón
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </SubmitModalWrapper>
  );
};

export default SubmitModal;